import { render, staticRenderFns } from "./lung.vue?vue&type=template&id=11bf8b14&scoped=true"
import script from "./lung.vue?vue&type=script&lang=ts"
export * from "./lung.vue?vue&type=script&lang=ts"
import style0 from "./lung.vue?vue&type=style&index=0&id=11bf8b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bf8b14",
  null
  
)

export default component.exports